(() => {
  const normalise = input => { const n = Math.max(1, Math.floor(Number(input?.value) || 1)); if (input) input.value = String(n); return n; };
  document.addEventListener('click', event => {
    const minus = event.target.closest('[data-card-qty-minus]');
    const plus = event.target.closest('[data-card-qty-plus]');
    if (!minus && !plus) return;
    event.preventDefault(); event.stopPropagation();
    const input = event.target.closest('[data-card-quick-add]')?.querySelector('[data-card-qty-input]');
    if (!input) return;
    const current = normalise(input);
    input.value = String(plus ? current + 1 : Math.max(1, current - 1));
  }, true);
})();
